import React, { Component } from "react";
import "./Unit.css";
import { Link } from "react-router-dom";
import { Breadcrumb, Alert, PageHeader} from "react-bootstrap";
import ListUnit from "./ListUnit";
import "../../react-select.min.css";

export default class Unit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stayOpen: false,
      isLoading: true,
      showAlertSuccess: false,
      showAlertError: false,
      alertMessage: '',
      refreshUnits: false
    };
  }

  handleAlertSuccess = (message) => {
	var newState = { alertMessage: message.message, showAlertSuccess: true };
	if (message.refresh) {
	  newState.refreshUnits = true;
	}
	this.setState(newState);
	setTimeout(function() { 
      if(this.state.showAlertSuccess){
        this.setState({ showAlertSuccess: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissSuccess = () => {
	this.setState({ showAlertSuccess: false });
  }

  handleAlertError = (message) => {
    this.setState({ alertMessage: message.message, showAlertError: true });
    setTimeout(function() { 
      if(this.state.showAlertError){
        this.setState({ showAlertError: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissError = () => {
	this.setState({ showAlertError: false });
  }
  
  render() {
    //const { disabled, stayOpen} = this.state;
    return (
      <div className="Unit">
        <Breadcrumb>
        	<Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
	        <Breadcrumb.Item active>Vehículos</Breadcrumb.Item>
	    </Breadcrumb>
      	<PageHeader>
	      Vehículos <small>Configuración</small>
	    </PageHeader>
        {
        	this.state.showAlertSuccess &&
        	<Alert bsStyle="success" onDismiss={this.handleDismissSuccess}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        {
        	this.state.showAlertError &&
        	<Alert bsStyle="danger" onDismiss={this.handleDismissError}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        <ListUnit {...this.props} refresh={this.state.refreshUnits} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/unit/Unit.js